(function () {
  function initPikuchiCollectionProducts(section) {
    if (!section || section.dataset.pkReady === 'true') return;
    section.dataset.pkReady = 'true';

    var tabs = section.querySelectorAll('[data-pk-tab]');
    var panels = section.querySelectorAll('[data-pk-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-pk-tab') === String(index);
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active && tab.scrollIntoView) {
          tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });

      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-pk-panel') === String(index);
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', 'hidden');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-pk-tab'));
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pk-collection-products]').forEach(initPikuchiCollectionProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPikuchiCollectionProducts(event.target.querySelector('[data-pk-collection-products]') || event.target);
  });
})();
